export default {"src":"/_next/static/media/urgent_group_icon.b18c0a8b.svg","height":80,"width":323,"blurWidth":0,"blurHeight":0};